export default function tocCustomizeWrapper() {
	const tocContainers = document.querySelectorAll("#toc_container");
	tocContainers.forEach(toc => {
		const wrapper = toc.closest(".wrapper");
		if (wrapper) {
			wrapper.classList.add("wrapper__toc");
		}
	});
}
